module.exports = __webpack_public_path__ + "static/media/443823281_433933549394675_6785775484460325339_n.71f74a76.jpg";